type FormatMaxCharsWords = {
  type: 'WORDS' | 'CHARS';
  max: number;
  input: string;
};

export const formatMaxCharsWords = ({ type, max, input }: FormatMaxCharsWords) => {
  const units = max;

  type === 'CHARS' ? formatChars() : formatWords();

  function formatChars() {
    if (input.length > units) {
      return input.slice(0, units) + '...';
    }

    return input;
  }

  function formatWords() {
    const checkWords = input.split(' ').length;

    if (checkWords > max) {
      return input.split(' ').slice(0, max).join(' ') + '...';
    } else {
      return input;
    }
  }

  return type === 'CHARS' ? formatChars() : formatWords();
};
